// GA4 user identity for Google tags.
//
// Only gtag("set") is used here: it updates tag settings without creating a
// Google Tag Manager event, so no event-triggered tag (such as the Meta pixel
// tag that forwards every custom event) fires because of it.
//
// Fire-and-forget and never throws, so tracking can never break a login or a
// signup.

// setupCredentialStorage runs on every /verify, so the user is only
// identified again when it changes.
let lastIdentified: string | null = null;

type AnalyticsUser = { userId?: string | number | null; email?: string | null };
type TagWindow = Window & { gtag?: (...args: unknown[]) => void; dataLayer?: unknown[] };

// GA4 user_id plus the email for enhanced conversions (gtag normalises and
// hashes it before sending).
export const identifyAnalyticsUser = ({ userId, email }: AnalyticsUser): void => {
  try {
    if (typeof window === "undefined") return;
    const w = window as TagWindow;
    if (typeof w.gtag !== "function") return;
    const identity = `${userId || ""}|${email || ""}`;
    if (identity === "|" || identity === lastIdentified) return;
    if (userId) {
      w.gtag("set", { user_id: String(userId) });
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push({ user_id: String(userId) });
    }
    if (email) w.gtag("set", "user_data", { email });
    lastIdentified = identity;
  } catch (_) {
    // tracking is optional
  }
};
